'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toString = exports.toStringWithoutTag = exports.parseLibUri = exports.createLibUri = undefined;

var _ramdaFantasy = require('ramda-fantasy');

const createLibUri = exports.createLibUri = (orgname, libname, tag) => ({
  orgname,
  libname,
  tag
}); // TODO: duplicates xod-cli/lib-uri.js

const parseLibUri = exports.parseLibUri = string => _ramdaFantasy.Maybe.toMaybe(string.match(/^([^@/]+?)\/([^@/]+?)(?:@([^@/]+?))?$/)).map(([, orgname, libname, tag]) => createLibUri(orgname, libname, tag || 'latest'));

const toStringWithoutTag = exports.toStringWithoutTag = libUri => `${libUri.orgname}/${libUri.libname}`;

const toString = exports.toString = libUri => `${toStringWithoutTag(libUri)}@${libUri.tag}`;


//////////////////
// WEBPACK FOOTER
// ../xod-pm/dist/lib-uri.js
// module id = 1464
// module chunks = 0